import type { DBEquipmentBookingLine } from "@/lib/db-types";
import { formatDayRange, type DateRange } from "./availability";

/** Pakkelisten (VIB-2920, mockup H). Avkrysningen lagres ikke. */

export interface PackingEntry {
  lineId: string;
  /** «Matthews c-stand × 2». */
  title: string;
  /** Notat og egne datoer. */
  details: string[];
  parts: string[];
}

type PackingLine = Pick<
  DBEquipmentBookingLine,
  "id" | "item_id" | "item_name" | "quantity" | "date_from" | "date_to" | "note" | "item_department_name"
>;

/** Hele perioden bookingene dekker, eller null uten linjer. */
export function packingPeriod(lines: Pick<DBEquipmentBookingLine, "date_from" | "date_to">[]): DateRange | null {
  if (lines.length === 0) return null;
  return {
    from: lines.reduce((min, l) => (l.date_from < min ? l.date_from : min), lines[0].date_from),
    to: lines.reduce((max, l) => (l.date_to > max ? l.date_to : max), lines[0].date_to),
  };
}

/** Avdelingene utstyret hentes fra, i rekkefølgen de først dukker opp. */
export function packingDepartments(lines: Pick<DBEquipmentBookingLine, "item_department_name">[]): string[] {
  return [...new Set(lines.map((l) => l.item_department_name).filter((n): n is string => !!n))];
}

export function packingEntries(lines: PackingLine[], partsByItem: Map<string, string[]>): PackingEntry[] {
  const period = packingPeriod(lines);
  return lines.map((l) => {
    const details: string[] = [];
    if (l.note) details.push(l.note);
    if (period && (l.date_from !== period.from || l.date_to !== period.to)) {
      details.push(`bare ${formatDayRange(l.date_from, l.date_to)}`);
    }
    const quantity = l.quantity > 1 ? ` × ${l.quantity}` : "";
    return {
      lineId: l.id,
      title: `${l.item_name}${quantity}`,
      details,
      parts: partsByItem.get(l.item_id) ?? [],
    };
  });
}
